import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import LogoArea from './LogoArea'
import MenuArea from './MenuArea'
import SocialLinkArea from './SocialLinkArea'
import ToggleMenuIcon from './ToggleMenuIcon'

const Wrapper = styled.div`
    position: relative;
    width: 100%; 
    height: 100px;
    display: flex;
    align-self: center;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 12%;
    padding-left:5%;
    background: rgb(0,0,0);
    background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.6110819327731092) 81%, rgba(255,255,255,0) 100%);

    @media screen and (max-width: 768px) {
        width: 100%;
        height: 65px;
        margin: 0;
    }
`
interface Props {
    connect: () => void,
    setIsHide: (e: any) => void,
    isHide: boolean,
    connected: boolean,
    address: string,
    chainId: number,
    killSession: () => void
}

const BuccaneerHeader: React.FC<Props> = ({
    connect,
    killSession,
    setIsHide,
    isHide,
    connected,
    address,
    chainId,
}) => {
    const [currentWidth, setCurrentWidth] = useState(0)
    useEffect(() => {
        function updateSize() {
            setCurrentWidth(window.innerWidth)
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    useEffect(() => {
        setIsHide(true)
        // eslint-disable-next-line
    }, [currentWidth]);
    return (
        <Wrapper>
            <LogoArea />
            <MenuArea
                displayMenu={isHide}
                connected={connected}
                address={address}
                chainId={chainId}
                killSession={killSession}
                openModal={connect}
            />
            <SocialLinkArea openModal={connect} connected={connected} />
            <ToggleMenuIcon openMenu={() => setIsHide(!isHide)} />
        </Wrapper>
    )
}

export default BuccaneerHeader
